import { sanitizeUrl } from "@braintree/sanitize-url";
import { Quill } from "react-quill";
/**
 * Allow-list of formats permitted in the Notes editor (rich toolbar).
 */
export const NOTES_QUILL_FORMATS = [
    "bold",
    "italic",
    "underline",
    "align",
    "list",
    "link"
];
/**
 * Allow-list of formats permitted in the Free Text widget (limited toolbar).
 */
export const FREE_TEXT_QUILL_FORMATS = [
    "bold",
    "italic",
    "list"
];
let safeLinkRegistered = false;
/**
 * Replaces Quill's default Link blot with one that runs hrefs through the
 * sanitize-url library, blocking javascript:, data:, vbscript: and other
 * dangerous protocols. Safe to call multiple times.
 */
export const registerSafeQuillLink = () => {
    if (safeLinkRegistered) {
        return;
    }
    // In test environments react-quill is mocked and Quill may be undefined.
    if (!Quill || typeof Quill.import !== "function" || typeof Quill.register !== "function") {
        return;
    }
    const Link = Quill.import("formats/link");
    const baseSanitize = Link.sanitize.bind(Link);
    class SafeLink extends Link {
        static sanitize(url) {
            const value = baseSanitize(url);
            // Sanitize-url returns "about:blank" for unsafe URLs.
            return sanitizeUrl(value);
        }
    }
    Quill.register(SafeLink, true);
    safeLinkRegistered = true;
};
